/* User defined models */
import { DynamicFormBase } from './dynamic-form-base.model';


export class ProSchedulerLinkedCombo extends DynamicFormBase<string> {
  controlType = 'linkedCombo';
  parentLabel: string;
  values: ComboBoxData[] = [];
  parentValue: string = '';
  childValues: string[];

  constructor(options: {} = {}) {
    super(options);
    this.parentLabel = options['parentLabel'] || '';
    this.values = !!options['values'] ? ComboBoxData.apiDataToComboBoxData(options['values']) : [];
  }

  setValue(secondary: string): void {
    // using find to minimize unnessecary loops
    if (!secondary || !this.values.find(parent => {
      return parent.children.find(child => {
        if (child.toLowerCase() === secondary.toLowerCase()) {
          this.childValues = parent.children;
          this.value = child;
          this.parentValue = parent.parent;
          return true;
        }
      });
    })) {
      this.childValues = [];
      this.value = '';
      this.parentValue = '';
    }
  }
}

class ComboBoxData {
  parent: string;
  children: string[];

  constructor(parent: string, children: string[]) {
    this.parent = parent;
    this.children = children;
  }

  static apiDataToComboBoxData(input: string) {
    let output: ComboBoxData[] = [];

    const obj: any = JSON.parse(input);

    Object.keys(obj).forEach((key: string) => {
      output.push(new ComboBoxData(key, obj[key]));
    });

    return output;
  }
}
